


































































































import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import Share from '@/components/organisms/Share.vue'
import { log } from '@/log'
import * as CurrentTime from '@/models/current-time/functions'
import { Context, ContextFactory } from '@/models/order-history/status/context/context'
import { PointFeatureIsEnabledService } from '@/services/api/point-feature'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import { DateFormat } from '@/util/format'
import { InstanceResolver } from '@/util/instanceResolver'
import { cancelIsNotAcceptable, getOrderCancellationState, OrderCancellationState } from '@spa/components/organisms/mypage/order/model/order-cancellation-state'
import { createOrderStatusViewModel, OrderStatusViewModel } from '@spa/components/organisms/mypage/order/model/order-status-view'
import { getReorderAcceptabilityState, ReorderAcceptabilityState } from '@spa/components/organisms/mypage/order/model/reorder-acceptability-state'
import OrderDetail from '@spa/components/organisms/mypage/order/OrderDetail.vue'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { OrderHistoryApiService, OrderHistoryJoinedWithProductclass } from '@spa/services/api/orderHistory'
import { OrderHistoryService } from '@spa/services/orderHistory'
import { Order } from '@spa/store/modules/orderHistory/types'
import { User } from '@spa/store/modules/user/types'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

@Component({
  components: {
    OrderDetail,
    Share,
    SpaErrorDialog,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class HistoryDetail extends Mixins<PluginMixin>(PluginMixin) {
  status: Status = Status.Pending

  message: string = ''
  showModal: boolean = false
  modalMessage: string = ''

  shareItem: OrderHistoryJoinedWithProductclass | null = null

  orderHistoryService = new OrderHistoryService()
  orderHistoryApiService = new OrderHistoryApiService()

  pointIsEnabled: boolean = false

  get isCompleted(): boolean {
    return this.status === Status.Completed
  }

  get isLoading(): boolean {
    return this.status === Status.Loading
  }

  get isFailed(): boolean {
    return this.status === Status.Failed
  }

  get user(): User {
    return this.$store.state.user.user
  }

  get order(): Order {
    return this.$store.state.orderHistory.item
  }

  get orderStatusContext(): Context {
    return ContextFactory.fromStore(this.order).create()
  }

  get isPreOrder(): boolean {
    return this.order.isPreOrder
  }

  get statusView(): OrderStatusViewModel {
    return createOrderStatusViewModel(this.orderStatusContext)
  }

  get reorderAcceptabilityState(): ReorderAcceptabilityState {
    return getReorderAcceptabilityState(this.orderStatusContext)
  }

  get orderCancellationState(): OrderCancellationState {
    return getOrderCancellationState(
      this.orderStatusContext,
      this.isPreOrder
    )
  }

  get orderIsCancellable(): boolean {
    return this.orderCancellationState.isCancellable
  }

  get messageForNotCancellable(): string | undefined {
    return cancelIsNotAcceptable(this.orderCancellationState) ?
      this.orderCancellationState.messageForNotCancellable :
      undefined
  }

  get deliveryWhen(): string | null {
    if (!this.order.isPreOrder || this.order.products.length === 0) {
      return null
    }
    /**
     * 予約注文の場合、商品は販売開始時期によって分類した状態で注文が行われる.
     * 従って、一つの予約注文に紐づく商品の販売開始時期はすべて同一であり、どのproductを使っても良い。
     * よって、先頭の一つを使って販売開始時期を取得する。
     *
     * start_atが同一、という意味ではなく、どのstart_atを選んでも得られる「販売開始時期」は同一、という意味.
     */
    const startAt = this.order.products[0].startAt

    if (!startAt) {
      return null
    }

    return DateFormat.partOfMonth(startAt)
  }

  get shouldShowNotesAboutPreOrder(): boolean {
    return this.order.isPreOrder && this.deliveryWhen !== null
  }

  get errorOnLoad() {
    return _.get(this.$store.state.orderHistory, 'error.load')
  }

  get shareItemBrandName(): string | null {
    return _.get(this.shareItem, 'root.brands.0.english_name') || null
  }

  get shareItemId(): string | null {
    return _.get(this.shareItem, 'root.id')
  }

  get shareItemColor(): string | null {
    if (!this.shareItem) {
      return null
    }

    return this.orderHistoryService.getColor(this.shareItem.fku, 'name') || null
  }

  get shareItemUrl(): string | null {
    if (!this.shareItem) {
      return null
    }

    const rootShortId = _.get(this.shareItem, 'root.shortid')

    const hostUrl = `${location.protocol}//${document.domain}`
    const itemUrl = `item/${rootShortId}?color=${this.shareItemColor}`

    if (InstanceResolver.isSingle()) {
      return `${hostUrl}/${itemUrl}`
    }

    return `${hostUrl}/${this.shareItemBrandName}/${itemUrl}`
  }

  async created() {
    this.status = Status.Loading

    await this.initOrder()
    await this.initShareItem()
    await this.initPointIsEnabled()

    if (this.errorOnLoad) {
      this.modalMessage = '購入履歴が取得できませんでした。'
      this.showModal = true
      this.status = Status.Failed

      return
    }

    this.status = Status.Completed
    EventBusForThirdParty.getInstance().publish('page-initialized', {
      url: window.location.href,
      initializedAt: CurrentTime.create().now,
      user: this.user,
    })
  }

  async initShareItem() {
    try {
      const salesOrderId = this.$router['history'].current.params.id
      const orderHistory = await this.orderHistoryApiService.get(salesOrderId)

      if (orderHistory.isLeft()) {
        return
      }

      const joined = await this.orderHistoryApiService.join(orderHistory.value['body'].data.item)
      const itemsInPublish = joined.filter((item) => {
        return item.root
      })

      if (joined.length < 1) {
        return
      }

      if (itemsInPublish.length < 1) {
        return
      }

      this.shareItem = _.head(itemsInPublish)!
    } catch (error) {
      log.error(error)
    }

    return
  }

  redirectToSignUp(): void {
    this.$router.push('/signup')
  }

  async initOrder(): Promise<void> {
    const orderId = this.$route.params.id

    await this.$store.dispatch('orderHistory/get', orderId)
  }

  async initPointIsEnabled(): Promise<void> {
    const availability = await PointFeatureIsEnabledService.create().isEnabled()
    this.pointIsEnabled = availability.on
  }
}
